module.exports = __webpack_public_path__ + "static/media/pic_ps5.f9a21c0c.png";